<div class="col-md-12 mb-30" [hidden]="Switcher_Viewer!='List'">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0" *ngIf="inner_17025_Cat.chart_type==2">Details '{{inner_17025_Cat.title}}'</h5>
      <h5 class="card-title border-0 pb-0" *ngIf="inner_17025_Cat.chart_type==3">Form Records '{{inner_17025_Cat.title}}'
      </h5>
      <br />
      <br />

      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="inner_17025_Cat.chart_type==2 && !Procssing" (click)="Set_Switcher_Viewer('Form',0)" type="button"
            class="btn btn-success"><i class="fa fa-plus"></i> Upload New Information </button>
          <button *ngIf="inner_17025_Cat.chart_type==3 && !Procssing" (click)="Set_Switcher_Viewer('Form',0)" type="button"
            class="btn btn-success"><i class="fa fa-plus"></i> Upload New Record </button>
          <button (click)="OnSet_Back_Action()" style="margin-left: 10px;" type="button" class="btn btn-warning"><i
              class="fa fa-mail-reply"></i> Back </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">

          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <thead style="background-color: #489b39; color: white;">
              <tr>
                <th>#</th>
                <th>ID</th>
                <th>File</th>
                <th>Title</th>
                <th>Created By</th>
                <th>Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of DataList_ChartFile
              | paginate
                      : {
                          id: 'DataList_UserTable',
                          itemsPerPage: 50,
                          currentPage: page,
                          totalItems: DataList_ChartFile.length
                        }">
                <td>{{DataList_ChartFile.indexOf(item)+1}}</td>
                <td>{{item.code}}</td>
                <td>
                  <a class="dropdown-item" target="_blank" href="{{BaseUrl}}File/Protocol17025{{item.src}}"
                    *ngIf="item.src"><i class="fa fa-download"></i> Download </a>
                </td>
                <td>{{item.title}}</td>
                <td>{{item.username}}</td>
                <td>{{item.subdate}}</td>
                <td>
                  <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                    <div class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Actions
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a class="dropdown-item" style="cursor: pointer;" (click)="Set_Switcher_Viewer('Form',item.id)"><i
                            class="fa fa-edit"></i>
                          Edit </a>
                        <a style="cursor: pointer;" class="dropdown-item" (click)="openModal(template,item)"><i
                            class="fa fa-remove"></i> Delete </a>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
      </div>
    </div>
    <pagination-controls id="DataList_UserTable" nextLabel="Next" previousLabel="Previous" (pageChange)="page = $event" ></pagination-controls>
  </div>
</div>


<div class="col-md-12 mb-30" *ngIf="Switcher_Viewer=='Form'">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0" *ngIf="inner_17025_Cat.chart_type==2 && Selected_Protocol17025ChartFile.id==0">Add New Record</h5>
      <h5 class="card-title border-0 pb-0" *ngIf="inner_17025_Cat.chart_type==3 && Selected_Protocol17025ChartFile.id==0">Add Record</h5>

      <h5 class="card-title border-0 pb-0" *ngIf="inner_17025_Cat.chart_type==2 && Selected_Protocol17025ChartFile.id>0">Edit Form </h5>
      <h5 class="card-title border-0 pb-0" *ngIf="inner_17025_Cat.chart_type==3 && Selected_Protocol17025ChartFile.id>0">Edit Record</h5>
      <br />
      <br />

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Select File</label>
          <input type="file" (change)="upload(file_chart.files)" #file_chart placeholder="Type here...">
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Title</label>
          <input type="text" class="form-control" [(ngModel)]="Selected_Protocol17025ChartFile.title" name="title_edit" placeholder="Type here...">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">Description</label>
          <textarea class="form-control" [(ngModel)]="Selected_Protocol17025ChartFile.dsc" name="dsc_edit" placeholder="Type here..."></textarea>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-12">
          <app-Protocol17025Cat_Check
            [DataList_Protocol17025Cat]="DataList_Protocol17025Cat"
            [Selected_Protocol17025Cat]="Selected_Tag"
            (On_Get_Selected_Tag)="OnGet_Selected_Tag($event)">

          </app-Protocol17025Cat_Check>
        </div>
      </div>

      <button *ngIf="!InProccessingAdd" (click)="AddEdit()" type="button" class="btn btn-info"> Save <i
          class="fa fa-plus"></i></button>
      <button (click)="Set_Switcher_Viewer('List',0)" style="margin-left: 10px;" *ngIf="!InProccessingAdd"
        type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>
    </div>

  </div>
</div>

<ng-template #template>
  <div class="modal-header">
     <h4 class="modal-title pull-left">Approve Delete  '{{Selected_Protocol17025ChartFile.code}}' </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-warning" (click)="Delete(Selected_Protocol17025ChartFile)"> Delete <i class="fa fa-remove"></i></button>
     <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">Close</button>
  </div>
</ng-template>
